import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter3_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist das Ziel von Crypto-Jacking?",
      options: [
        {
          value: "A",
          label:
            "Das digitale Entführen von Cryptowährungen von einem Computer, um Lösegeld zu erpressen.",
        },
        {
          value: "B",
          label:
            "Das illegale Anzapfen der Rechenleistung eines Computers, um damit Cryptowährung zu schürfen.",
        },
      ],
      correct: "B",
    },
    {
      question: "Frage 2: Wie verbreiten sich Würmer in einem Netzwerk?",
      options: [
        {
          value: "A",
          label:
            "Sie kopieren und verbreiten sich selbst ohne Benutzerinteraktion auf andere Geräte.",
        },
        {
          value: "B",
          label:
            "Sie werden nur durch das manuelle Öffnen von infizierten E-Mail-Anhängen aktiviert.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 3_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
   
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "3_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("3_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 3_1.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "3_1",
              completedChapters: ["3_1"],
            });
          console.log("Dokument erstellt mit Kapitel 3_1");
        }

        navigate("/3_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  3. Angriffe und Risiken
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Malware
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 3: Angriffe und Risiken</h3>
          <h2 className="text-center p-3">Malware</h2>
          <img
            src="/images/malware.webp"
            alt="Malware"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Malware, Abkürzung für "malicious software" (schädliche Software),
            ist Code, der entwickelt wurde, um unerwünschte und schädliche
            Aktionen auf dem Computer oder Netzwerk auszuführen. Malware kann
            Daten stehlen, Systeme beschädigen oder die Kontrolle über ein
            System übernehmen. Die verschiedenen Typen von Malware unterscheiden
            sich in ihrer Funktionsweise und ihren Zielen, was wiederum
            unterschiedliche Abwehrstrategien erfordert.
            <br />
            <br />
            Die Auswirkungen von Malware reichen von geringfügigen Störungen bis
            hin zu schwerwiegenden Schäden wie Datenverlust, finanziellen
            Verlusten und Datenschutzverletzungen.
            <br />
            <br />
            Malware kann auf verschiedene Weisen in Systeme gelangen. Eine
            Möglichkeit ist z. B. die physische Verbreitung durch den Gebrauch
            von USB-Speichern oder anderer externer Speichermedien. Die
            virtuelle Verbreitung erfolgt über gängige Tools für die
            Zusammenarbeit, infizierte Webseiten oder Downloads, bei denen
            Malware automatisch und ohne das Wissen des Nutzers auf dessen
            System geladen wird. <br />
            <br />
            Das sind die bekanntesten Malware-Arten und ihre Besonderheiten:
          </p>
        </div>

        <div className="grey-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h3 className="p-5">Viren</h3>
              <img
                src="/images/viren2.png"
                class=""
                alt=""
                style={{
                  maxHeight: "150px",
                }}
              />
              <p className="col-lg-11 mx-auto">
                <br />
                <br />
                <strong>Was sind Viren?</strong>
                <br />
                <br />
                Viren sind eine Art von Malware, die sich selbst in andere
                Programme oder Dateien einschleusen und ohne das Wissen des
                Benutzers auf einem Computer verbreiten. Der Begriff "Virus"
                bedeutet "Gift", womit die zerstörerische Natur dieser Malware
                umschrieben wird.
                <br />
                <br />
                Viren können unterschiedlichste Folgen aufweisen: Sie können z.
                B. Daten sperren oder löschen, Systeme verlangsamen oder ganz
                abstürzen lassen. Obwohl es auch seltene Beispiele für gutartige
                Viren gibt, die weniger schädlich sind, wie der Cruncher-Virus,
                der Dateien komprimiert, handelt es sich bei den meisten Viren
                um bösartige Programme, die darauf abzielen, Schaden anzurichten
                oder sensible Daten zu stehlen.
                <br />
                <br />
                <strong>Wie läuft ein Virusangriff ab?</strong>
                <br />
                <br />
                Ein Virus wird in der Regel über infizierte Dateien oder
                Programme auf ein System übertragen. Dies kann durch das Öffnen
                von{" "}
                <Link to="/2_4" className="icon-link">
                  {" "}
                  <svg className="bi" aria-hidden="true">
                    {" "}
                    <use xlinkHref="#book"></use>{" "}
                  </svg>{" "}
                  Phishing-E-Mails,{" "}
                </Link>
                den Besuch von manipulierten Websites oder das Herunterladen
                infizierter Software geschehen. Einmal auf dem Computer,
                verbreitet sich der Virus, indem er sich in andere Programme
                oder Dateien kopiert und diese infiziert. Häufig geschieht dies
                unbemerkt, sodass der Virus erst entdeckt wird, wenn er bereits
                erhebliche Schäden angerichtet hat.
              </p>
              <p className="col-lg-10 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Ein besonders gefährlicher Virus war der Zeus-Virus, der
                erstmals 2007 entdeckt wurde. Zeus wurde entwickelt, um
                Finanzdaten wie Bankzugangsdaten zu stehlen. Dazu griff er
                Informationen von infizierten Systemen ab, während Benutzer ihre
                Online-Bankkonten nutzten. Der Virus konnte Tastatureingaben
                (Keylogging) aufzeichnen und so Passwörter und andere
                vertrauliche Daten erfassen. Zeus führte zu erheblichen
                finanziellen Verlusten bei seinen Opfern und breitete sich rasch
                über Phishing-E-Mails und kompromittierte Websites aus.{" "}
              </p>
              <p className="col-lg-11 mx-auto">
                <strong>Wie kann man sich vor Viren schützen?</strong>
              </p>

              <p className="col-lg-10 text-start mx-auto">
                <strong>Antiviren-Software:</strong> <br />
                Installieren und regelmäßiges aktualisieren von einer
                zuverlässigen Antiviren-Software, um Viren zu erkennen und zu
                blockieren, bevor sie sich verbreiten können.
                <br />
                <br />
                <strong>Vorsicht bei E-Mails: </strong> <br />
                Nutzer sollten keine Anhänge oder Links aus verdächtigen E-Mails
                öffnen, besonders wenn sie von unbekannten Absendern stammen.
                Phishing-E-Mails sind ein häufiger Verbreitungsweg für Viren.{" "}
                <br />
                <br />
                <strong>Regelmäßige Sicherheitsupdates: </strong>
                <br />
                Das Betriebssystem und alle Programme sollten auf dem neuesten
                Stand gehalten werden. Viele Viren nutzen Sicherheitslücken in
                veralteter Software aus, um sich zu verbreiten.
                <br />
                <br />
                <strong>Downloads aus vertrauenswürdigen Quellen:</strong>{" "}
                <br />
                Software sollte nur von offiziellen und vertrauenswürdigen
                Websites heruntergeladen werden, um das Risiko einer Infektion
                durch manipulierte Software zu minimieren.
                <br />
                <br />
                <strong>Regelmäßige Backups:</strong> <br />
                Backups der wichtigsten Dateien sollten regelmäßig erstellt
                werden. Im Fall einer Infektion können so die Daten wieder
                hergestellt werden.
                <br />
              </p>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h3 className="p-5">Würmer</h3>
              <img
                src="/images/wurm.webp"
                class=""
                alt=""
                style={{
                  maxHeight: "180px",
                }}
              />
              <p className="col-lg-11 mx-auto">
                <br />
                <br />
                <strong>Was sind Würmer?</strong>
                <br />
                <br />
                Gefährlich an Würmern ist deren selbständiges Verbreiten über
                Netzwerke, ohne dass sie auf eine Wirtsdatei oder eine
                Benutzerinteraktion (z. B. einen Download-Link) angewiesen sind.
                Sobald sie in ein System eingedrungen sind, suchen sie nach
                weiteren vernetzten Geräten, die sie angreifen können, was oft
                zu einer Überlastung von Netzwerken führt. Diese Überlastung
                kann den Datenverkehr erheblich verlangsamen oder sogar
                vollständig lahmlegen. Zusätzlich zu ihrer Verbreitungsfähigkeit
                können Würmer auch Daten sammeln und an Angreifer senden oder
                Systeme direkt beschädigen.
                <br />
                <br />
                <strong>Wie läuft ein Wurmangriff ab?</strong>
                <br />
                <br />
                Würmer nutzen Sicherheitslücken in Netzwerken, Betriebssystemen
                oder Anwendungen aus, um auf andere Geräte innerhalb eines
                Netzwerks zuzugreifen und sich dorthin zu kopieren. Ein
                klassisches Beispiel dafür ist die Verbreitung über
                E-Mail-Anhänge. Hierbei wird der Wurm als scheinbar harmloser
                Anhang einer E-Mail verschickt. Sobald der Empfänger den Anhang
                öffnet, infiziert der Wurm das System und verschickt sich selbst
                an alle Kontakte im Adressbuch weiter, wodurch er sich schnell
                verbreiten kann.
              </p>
              <p className="col-lg-10 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Der Conficker-Wurm, auch bekannt als Downadup, wurde erstmals
                2008 entdeckt. Er verbreitete sich weltweit, indem er eine
                Sicherheitslücke in Windows ausnutzte. Conficker konnte sich
                ohne Benutzerinteraktion über Netzwerke und Wechseldatenträger
                wie USB-Sticks selbst kopieren und weiterleiten. Vor allem
                nutzte der Wurm für seine Ausbreitung die Infektion durch
                E-Mail-Anhänge, wodurch der Wurm dann an alle Kontakte im
                Adressbuch weiterverschickt wurde. Gleichzeitig deaktivierte der
                Wurm Sicherheitsdienste und blockierte den Zugang zu
                Antiviren-Websites, wodurch er schwer zu entfernen war.
                Millionen von Computern, einschließlich Regierungs- und
                Unternehmensnetzwerken, wurden so infiziert. Er verursachte
                enorme finanzielle Schäden sowie Betriebsunterbrechungen.
              </p>
              <p>
                <strong>Wie kann man sich vor Würmern schützen?</strong>
              </p>{" "}
              <p className="col-lg-10 text-start mx-auto">
                <strong>Firewalls: </strong> <br />
                Eine Firewall sollte aktiviert werden, um unautorisierte
                Verbindungen zu blockieren. Firewalls verhindern, dass Würmer
                sich durch das Netzwerk bewegen und neue Systeme infizieren.{" "}
                <br />
                <br />
                <strong>Automatische Ausführung deaktivieren:</strong> <br />
                Die automatische Ausführung von Programmen auf
                Wechseldatenträgern wie USB-Sticks sollte deaktiviert werden.
                Würmer können sich über Wechseldatenträger verbreiten und
                infizieren das System, sobald der Datenträger angeschlossen
                wird. <br />
                <br />
                <strong>Netzwerksegmentierung:</strong> <br />
                In Unternehmensumgebungen hilft die Segmentierung (Aufteilung in
                kleinere Teile) des Netzwerks, um die Ausbreitung eines Wurms zu
                begrenzen. Wenn ein System infiziert wird, verhindert die
                Segmentierung, dass sich der Wurm auf andere Systeme im Netzwerk
                ausbreiten kann.
                <br />
                <br />
                Daneben bieten auch hier eine{" "}
                <strong>Antiviren-Software</strong>,{" "}
                <strong>regelmäßige Sicherheitsupdates </strong> und die{" "}
                <strong>Vorsicht beim Öffnen von E-Mail-Anhängen</strong>
                Schutz vor Würmern.
              </p>
            </div>
          </div>
        </div>

        <div className="gelb-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h3 className="p-5">Trojaner</h3>
              <img
                src="/images/trojaner.webp"
                class=""
                alt=""
                style={{
                  maxHeight: "150px",
                }}
              />
              <p className="col-lg-11 mx-auto">
                <br />
                <br />
                <strong>Was sind Trojaner?</strong>
                <br />
                <br />
                Ein Trojaner tarnt sich als harmlose oder nützliche Software, um
                Benutzer dazu zu verleiten, sie zu installieren. Einmal auf
                einem System installiert, kann ein Trojaner eine Vielzahl
                schädlicher Aktionen ausführen. Dazu gehören das Öffnen von
                sogenannten Hintertüren, über die Angreifer Zugriff auf das
                System erhalten, das Stehlen sensibler Informationen oder das
                Installieren weiterer Schadsoftware. Diese bösartigen Programme
                nutzen häufig Social-Engineering-Techniken, um den Benutzer zu
                täuschen und die Schadsoftware unbemerkt auf ein Gerät zu
                schleusen. <br />
                <br />
                Das primäre Ziel eines Trojaners ist in der Regel das Stehlen
                sensibler Daten, wie Passwörter, Kreditkarteninformationen oder
                Unternehmensgeheimnisse. Angreifer können diese Informationen
                dann entweder für Betrugszwecke nutzen oder sie weiterverkaufen.
                <br />
                <br />
                <strong>Wie läuft ein Trojanerangriff ab?</strong>
                <br />
                <br />
                Der Benutzer lädt unwissentlich eine infizierte Datei herunter
                oder installiert ein bösartiges Programm, das sich als legitime
                Software ausgibt. Einige Trojaner, wie z. B. Remote Access
                Trojaner (RATs), ermöglichen es den Angreifern, die vollständige
                Kontrolle über das infizierte Gerät zu übernehmen. Dies gibt den
                Angreifern die Möglichkeit, sensible Daten zu exfiltrieren,
                Systeme zu manipulieren oder weitere Geräte im selben Netzwerk
                zu infizieren.
                <br />
                <br />
                Einmal installiert arbeiten Trojaner oft im Hintergrund und
                bleiben unbemerkt, während sie wichtige Informationen sammeln
                oder den Computer für zusätzliche Angriffe missbrauchen. Einige
                Varianten beschädigen sogar aktiv Daten oder das Betriebssystem
                selbst.
              </p>
              <p className="col-lg-10 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Ein bekannter Trojaner ist Emotet, der erstmals 2014 entdeckt
                wurde. Emotet erlangte Berühmtheit, weil er speziell auf
                Finanzdaten abzielt und über Jahre hinweg kontinuierlich
                weiterentwickelt wurde. 2021 gelang es den
                Strafverfolgungsbehörden, die Infrastruktur von Emotet
                vorübergehend stillzulegen, doch der Trojaner tauchte in einer
                neuen Version wieder auf und bleibt eine ernsthafte Bedrohung.
                Trojaner wie Emotet können zu erheblichen finanziellen Schäden
                führen und die Vertraulichkeit sensibler Unternehmensdaten
                gefährden.
              </p>
              <p>
                <strong>Wie kann man sich vor Trojanern schützen?</strong>
              </p>{" "}
              <p className="col-lg-10 text-start mx-auto">
                <strong>Downloads nur aus vertrauenswürdigen Quellen:</strong>{" "}
                <br />
                Software sollte nur von offiziellen, vertrauenswürdigen
                Webseiten oder App-Stores heruntergeladen werden. Raubkopien
                oder unbekannte Quellen sind häufig mit Trojanern verseucht.{" "}
                <br />
                <br />
                <strong>
                  {" "}
                  <Link to="/2_3#mfa" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    Multi-Faktor-Authentifizierung (MFA):
                  </Link>{" "}
                </strong>{" "}
                <br />
                Durch die Nutzung von MFA kann der Nutzer sicherstellen, dass
                selbst wenn ein Angreifer Zugangsdaten durch einen Trojaner
                stiehlt, er nicht ohne weiteres auf wichtige Konten zugreifen
                kann.
                <br />
                <br />
                Daneben gelten auch hier <strong>
                  Antiviren-Software,{" "}
                </strong>{" "}
                die Installation einer <strong>Firewall, </strong>
                <strong>regelmäßige Sicherheitsupdates, </strong>{" "}
                <strong>Vorsicht beim Öffnen von E-Mail-Anhängen</strong> und
                die <strong>Netzwerksegmentierung</strong> als Schutz vor
                Trojanern.
              </p>
            </div>
          </div>
        </div>

        <div className="grey-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h3 className="p-5">Spyware</h3>
              <img
                src="/images/spy.png"
                class=""
                alt=""
                style={{
                  maxHeight: "130px",
                }}
              />
              <p className="col-lg-11 mx-auto">
                <br />
                <br />
                <strong>Was ist Spyware?</strong>
                <br />
                <br />
                Spyware ist Software, die unbemerkt auf einem Computer
                installiert wird, um den Benutzer "auszuspionieren" und so
                heimlich Informationen über die Aktivitäten des Benutzers zu
                sammeln. Spyware kann eine Vielzahl von Informationen erfassen,
                darunter Tastatureingaben, besuchte Webseiten und sogar sensible
                Daten wie Passwörter, Kreditkarteninformationen oder
                Unternehmensgeheimnisse. Die gesammelten Daten werden dann an
                Dritte weitergeleitet (z. B. an Werbe- und Datenfirmen oder
                kriminelle Akteure, die sie für betrügerische Aktivitäten
                nutzen).
                <br />
                <br />
                <strong>Wie läuft ein Spywareangriff ab?</strong>
                <br />
                <br />
                Zunächst muss die Spyware auf das Gerät gelangen. Dies geschieht
                häufig durch den Download von kostenloser Software oder über
                bösartige Links und Werbeanzeigen. Sobald der Benutzer die
                infizierte Software herunterlädt oder auf einen schädlichen Link
                klickt, wird die Spyware unbemerkt auf das Gerät geladen.
                <br />
                <br />
                Nach der Installation wechselt die Spyware in den{" "}
                <strong>Stealth-Modus, </strong> um ihre Präsenz zu verbergen.
                Dafür tarnt sie sich, indem sie sich legitime Dateinamen gibt
                oder Systemprozesse imitiert. Um nicht entdeckt zu werden, kann
                die Spyware sogar Sicherheitsmaßnahmen wie Firewalls und
                Antivirenprogramme umgehen oder deaktivieren. Oft integriert sie
                sich auch in die Autostartprozesse des Systems, sodass sie bei
                jedem Start des Geräts erneut aktiv wird. <br />
                <br />
                Sobald sie aktiv ist, beginnt die Spyware mit der{" "}
                <strong>Datenerfassung. </strong>Abhängig von der Art der
                Spyware werden verschiedene Methoden zur Sammlung von
                Informationen verwendet werden. Beispielsweise zeichnen{" "}
                <strong>Keylogger </strong> alle Tastatureingaben auf, um
                sensible Daten wie Passwörter oder Kreditkarteninformationen zu
                stehlen. Andere Spyware-Programme überwachen das Surfverhalten
                oder erstellen Screenshots von Benutzeraktivitäten. Schließlich
                werden die gesammelten Informationen an einen{" "}
                <span
                  data-tooltip-id="tooltip-remote"
                  data-tooltip-content="Ein Remote-Server ist ein Computer oder System, das sich an einem entfernten Standort befindet und über ein Netzwerk, wie das Internet, aufgerufen werden kann, um Dienste bereitzustellen oder Daten zu speichern."
                  className="custom-tooltip-trigger"
                >
                  {" "}
                  Remote-Server{" "}
                </span>
                gesendet, der von den Angreifern kontrolliert wird. Die
                gestohlenen Daten können dann für Betrug, Identitätsdiebstahl
                oder gezielte Angriffe verwendet werden.
                <br />
                <br />
                Besonders gefährlich ist <strong>mobile Spyware, </strong>die
                auf mobilen Geräten Standortdaten erfassen, oder sogar Zugriff
                auf Kamera und Mikrofon erhalten kann, um die
                Benutzeraktivitäten noch umfangreicher auszuspionieren.
              </p>
              <ReactTooltip
                id="tooltip-remote"
                place="top"
                className="custom-tooltip"
              />
              <p className="col-lg-10 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Ein bekanntes Beispiel für Spyware ist der FinFisher, der häufig
                von Regierungen und Strafverfolgungsbehörden eingesetzt wird, um
                gezielt Verdächtige auszuspionieren. FinFisher (auch bekannt als
                FinSpy) ist eine kommerzielle Überwachungssoftware, die von der
                Firma Gamma Group entwickelt wurde. FinFisher kann auf
                infizierten Geräten sensible Daten erfassen, darunter
                Passwörter, Bildschirmaufnahmen und sogar den Zugriff auf Kamera
                und Mikrofon ermöglichen. Diese Spyware wird als Trojaner in
                legitimer Software versteckt und ist daher besonders schwer zu
                entdecken. FinFisher wurde in der Vergangenheit mehrfach dafür
                kritisiert, dass es auch gegen Menschenrechtsaktivisten und
                Oppositionspolitiker eingesetzt wurde, was ethische und
                rechtliche Fragen aufwirft.
              </p>
              <p>
                <strong>Wie kann man sich vor Spyware schützen?</strong>
              </p>{" "}
              <p className="col-lg-10 text-start mx-auto">
                <strong>Antiviren- mit Antispyware-Software:</strong> <br />
                Zu empfehlen ist ein gutes Antivirenprogramm mit eingebauter
                Spyware-Erkennung. Viele solcher Sicherheitslösungen bieten
                spezielle Funktionen zur Erkennung und Entfernung von Spyware.
                <br />
                <br />
                <strong>Sichere Downloads: </strong> <br />
                Software sollte nur von vertrauenswürdigen Quellen
                heruntergeladen werden. Das Herunterladen von Freeware oder
                Shareware aus unbekannten Quellen sollte vermieden werden.{" "}
                <br />
                <br />
                <strong>Browser-Sicherheit erhöhen:</strong>
                <br /> Browser-Plugins wie Ghostery oder uBlock Origin sollten
                genutzt werden, um Tracker und potenzielle Spyware zu
                blockieren, die sich durch Werbeanzeigen oder{" "}
                <span
                  data-tooltip-id="tooltip-cookie"
                  data-tooltip-content="Ein Cookie ist eine kleine Textdatei, die von einer Website auf deinem Gerät gespeichert wird, um Informationen wie Einstellungen, Login-Daten oder Surfverhalten für zukünftige Besuche zu speichern."
                  className="custom-tooltip-trigger"
                >
                  {" "}
                  Cookies{" "}
                </span>{" "}
                einschleusen.
                <br />
                <br />
                Daneben gelten auch hier die Installation einer{" "}
                <strong>Firewall, </strong>
                <strong>regelmäßige Sicherheitsupdates, </strong>{" "}
                <strong>Vorsicht beim Öffnen von E-Mail-Anhängen </strong> und
                <strong>Netzwerksegmentierung</strong> als geeignete
                Schutzmaßnahmen vor Spyware.
              </p>
              <ReactTooltip
                id="tooltip-cookie"
                place="top"
                className="custom-tooltip"
              />
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h3 className="p-5">
                Crypto Jacking oder Crypto Mining mittels Malware
              </h3>
              <img
                src="/images/crypto.png"
                class=""
                alt=""
                style={{
                  maxHeight: "130px",
                }}
              />
              <p className="col-lg-11 mx-auto">
                <br />
                <br />
                <strong>Was ist Crypto Jacking?</strong>
                <br />
                <br />
                Crypto-Mining ist ein legitimer Prozess, bei dem Cryptowährungen
                durch die Lösung komplexer mathematischer Aufgaben mit der
                Rechenleistung des eigenen Computers gewonnen werden (geschürft
                werden). Beim Crypto Jacking wird Malware auf fremden Rechnern
                installiert, um unbemerkt und illegal Cryptowährungen zu
                schürfen. Für das Schürfen ist sehr viel Rechnerleistung
                erforderlich, wofür die Leistung des infizierten Rechners genutzt
                wird. Diese Malware wird in der Regel über manipulierte
                Webseiten, infizierte Software oder durch sogenannte
                "Drive-by-Downloads" verbreitet. Bei einem Drive-by-Download
                wird die Schadsoftware auf den Computer geladen, sobald der
                Nutzer eine infizierte Webseite besucht, ohne dass der Nutzer
                etwas davon bemerkt. Eine weitere gängige Methode besteht darin,
                raubkopierte Software zu nutzen, die als Träger für die Crypto
                Mining Malware fungiert. Sobald die Malware auf dem Gerät
                installiert ist, beginnt sie im Hintergrund Cryptowährungen wie
                Bitcoin, Monero oder Ethereum für die Angreifer zu schürfen.
                <br />
                <br />
                <strong>Wie läuft ein Crypto Jacking Angriff ab?</strong>
                <br />
                <br />
                Crypto Jacking Malware nutzt nur einen Teil der Rechenleistung
                des infizierten Geräts, um ihre Aktivität möglichst unauffällig
                zu halten. Wenn der Computer dauerhaft bei 100% Auslastung
                laufen würde, könnte der Nutzer auf die ungewöhnliche Belastung
                aufmerksam werden und Gegenmaßnahmen ergreifen. Um die Tarnung
                zu perfektionieren, sind einige Crypto Mining Malware-Varianten
                so fortschrittlich, dass sie ressourcenintensive Anwendungen wie
                Spiele oder Videobearbeitungsprogramme erkennen und ihre eigene
                Aktivität automatisch drosseln, wenn solche Anwendungen
                gestartet werden.
                <br />
                <br />
                Häufig nutzen Angreifer sogenannte{" "}
                <strong>Bot-Netzwerke</strong>. Dabei werden mehrere infizierte
                Geräte miteinander verbunden, um die Rechenleistung der
                betroffenen Computer zu bündeln und noch effizienter
                Cryptowährungen zu schürfen. Ein Bot-Netzwerk kann aus Tausenden
                von Geräten bestehen, wodurch der Gewinn für die Angreifer enorm
                erhöht wird. Bekannte Beispiele für Crypto Mining Malware sind
                Coinhive, Vivin, XMRig, Lucifer, WannaMine und RubyMiner.
              </p>

              <p className="col-lg-10 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Ein berüchtigtes Beispiel für Crypto Jacking ist der Fall von
                Coinhive, einer mittlerweile abgeschalteten Software, die
                ursprünglich als legitimes Tool entwickelt wurde, um Websites
                durch das Schürfen von Monero zu finanzieren. Leider wurde
                Coinhive von Cyberkriminellen missbraucht, indem sie den
                Mining-Code heimlich auf Websites einschleusten, sodass die
                Computer der Besucher dieser Websites ohne deren Wissen zur
                Cryptowährungs-Schürfung verwendet wurden. Dies führte zu einer
                riesigen Welle von Crypto Jacking Vorfällen weltweit, die vor
                allem ungeschützte Nutzer betrafen.
              </p>
              <p>
                <strong>Wie kann man sich vor Crypto Jacking schützen?</strong>{" "}
              </p>
              <p className="col-lg-10 text-start mx-auto">
                <strong>Browser-Erweiterungen: </strong> <br />
                Browser-Plugins wie NoCoin oder MinerBlock blockieren
                verdächtige Crypto Mining Skripte auf Webseiten. Diese Tools
                sind speziell dafür entwickelt, um Crypto Mining-Aktivitäten zu
                erkennen und zu verhindern, dass die Rechenleistung des
                Computers missbraucht wird. <br />
                <br />
                <strong>Achtsamkeit beim Surfen: </strong> <br />
                Der Besuch von verdächtigen Webseiten, insbesondere von Seiten,
                die Raubkopien von Software oder illegalen Inhalten anbieten,
                sollte vermieden werden. Diese Seiten sind häufig mit Malware
                verseucht. <br /> <br />
                <strong>Überwachung der Systemleistung: </strong> <br />
                Der Nutzer sollte die Auslastung seines Systems im Auge
                behalten. Ein plötzlicher und unerklärlicher Anstieg der CPU-
                oder GPU-Auslastung kann ein Hinweis auf Crypto Jacking sein.
                Tools wie der Task-Manager unter Windows oder der
                Aktivitätsmonitor unter macOS helfen, ungewöhnliche Aktivitäten
                zu erkennen.
                <br />
                <br />
                Daneben gelten auch hier eine{" "}
                <strong>regelmäßige Sicherheitsupdates </strong> und die{" "}
                <strong>Vorsicht beim Öffnen von E-Mail-Anhängen</strong> als
                Schutz vor Crypto Jacking.
              </p>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="pt-5 container">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />{" "}
              <Element name="antivirus">
                <h3 className="p-5">Schutzmaßnahmen und Prävention</h3>
                <p className="col-lg-11 mx-auto">
                  {" "}
                  <strong>Antivirus- und Antimalware-Tools </strong> sind
                  essenzielle Sicherheitsprogramme, die entwickelt wurden, um
                  Malware zu erkennen, zu blockieren und zu entfernen. Sie
                  bieten Echtzeitschutz, indem sie kontinuierlich Dateien und
                  Prozesse überwachen, und ermöglichen zudem manuelle Scans, um
                  gezielt bestimmte Bereiche eines Systems zu überprüfen. <br />
                  <br />
                  Malware wird dabei entweder über{" "}
                  <span
                    data-tooltip-id="tooltip-beksig"
                    data-tooltip-content="Bekannte Signaturen sind einzigartige digitale Fingerabdrücke von bereits identifizierter Schadsoftware gemeint. Diese Signaturen bestehen aus spezifischen Code-Fragmenten oder Mustern, die Antivirus-Programme nutzen, um Malware zuverlässig zu erkennen und zu blockieren. Regelmäßige Updates der Signaturdatenbank stellen sicher, dass auch neu entdeckte Bedrohungen erkannt werden können."
                    className="custom-tooltip-trigger"
                  >
                    {" "}
                    bekannte Signaturen{" "}
                  </span>{" "}
                  erkannt oder durch{" "}
                  <span
                    data-tooltip-id="tooltip-heuan"
                    data-tooltip-content="Heuristische Analysen sind Verfahren, mit denen Antivirus- und Antimalware-Programme unbekannte Bedrohungen erkennen können, die noch nicht in der Signaturdatenbank verzeichnet sind. Statt nach spezifischen Mustern zu suchen, analysiert die heuristische Methode das Verhalten von Dateien und Programmen auf verdächtige Aktivitäten, wie das eigenständige Verändern von Systemdateien oder das Verschlüsseln von Daten. So können auch neue oder veränderte Schadsoftware-Varianten frühzeitig entdeckt werden."
                    className="custom-tooltip-trigger"
                  >
                    {" "}
                    heuristische Analysen{" "}
                  </span>{" "}
                  auf verdächtige Verhaltensmuster untersucht. Bekannte
                  Programme wie Windows Defender, Kaspersky Antivirus, Norton
                  Antivirus, Bitdefender und Malwarebytes setzen dabei auf
                  regelmäßige Updates ihrer Signaturdatenbanken, um stets vor
                  den neuesten Bedrohungen geschützt zu sein.
                  <br />
                  <br />
                  Für eine effektive Nutzung ist es wichtig, den Echtzeitschutz
                  immer aktiviert zu lassen, regelmäßige Systemscans
                  durchzuführen und die Software aktuell zu halten.
                  <br />
                  <br />
                  Wenn eine verdächtige Datei die möglicherweise Malware
                  enthält, von einer Antiviren- oder Sicherheitssoftware erkannt
                  wird, wird sie in <strong> Quarantäne verschoben. </strong> In
                  diesem isolierten Bereich wird die Datei von anderen
                  Systembereichen und Programmen getrennt, sodass sie keinen
                  weiteren Schaden anrichten kann. Die Sicherheitssoftware
                  verhindert, dass die Datei ausgeführt oder verändert wird und
                  verhindert, dass andere Anwendungen oder Benutzer auf sie
                  zugreifen.
                  <br />
                  <br />
                  Anschließend wird tiefergehend analysiert, ob die Datei
                  tatsächlich schädlich ist. Moderne Sicherheitslösungen
                  verwenden auch <strong> Sandboxing, </strong> bei dem die
                  Datei in einer sicheren, virtuellen Umgebung ausgeführt wird,
                  um zu beobachten, wie sie sich verhält. Zeigt die Datei
                  typische Verhaltensweisen von Malware, wie das Kopieren auf
                  Systemebene oder das Kommunizieren mit verdächtigen Servern,
                  wird sie als Bedrohung eingestuft.
                  <br />
                  <br />
                  Ist die Analyse abgeschlossen, hat der Benutzer in der Regel
                  mehrere Optionen: Die Datei kann gelöscht, desinfiziert oder –
                  falls sich herausstellt, dass sie ungefährlich ist –
                  wiederhergestellt werden. Dieser Prozess stellt sicher, dass
                  Bedrohungen erkannt und neutralisiert werden, bevor sie das
                  System kompromittieren können. Die Sicherheitssoftware kann
                  die Ergebnisse der Analyse zudem an eine zentrale Datenbank
                  melden, um andere Systeme besser vor ähnlichen Bedrohungen zu
                  schützen.
                </p>{" "}
              </Element>
              <ReactTooltip
                id="tooltip-beksig"
                place="top"
                className="custom-tooltip"
              />{" "}
              <ReactTooltip
                id="tooltip-heuan"
                place="top"
                className="custom-tooltip"
              />
              <img
                src="/images/ki.png"
                class="rounded-circle p-2 "
                alt="ki"
                style={{
                  maxWidth: "150px",
                  height: "auto",
                }}
              />
              <h2 className="p-3">Malware und der Einfluss von KI</h2>
              <p className="col-lg-11 mx-auto">
                Die Verwendung von Künstlicher Intelligenz KI (oder AI
                Artificial Intelligence) in der Entwicklung und Bekämpfung von
                Malware biete sowohl den Angreifern als auch den Verteidigern
                neue Möglichkeiten. Angreifer nutzen KI, um ihre Angriffe zu
                verfeinern, zu automatisieren und schwerer erkennbar zu machen.
                So werden z. B. KI-Modelle trainiert, um nach bekannten
                Schwachstellen in spezifischen Systemen zu suchen und diese dann
                gezielt anzugreifen.
                <br />
                <br />
                Mit Hilfe der KI kann auch eine so genannte{" "}
                <strong> polymorphe Malware </strong>
                erstellt werden, die ihren Code und ihr Verhalten ständig
                ändert, um einer Erkennung durch traditionelle
                Antivirenprogramme zu entgehen. KI-gesteuerte Malware kann
                lernen, wie sie Sicherheitssoftware umgehen kann oder ob sie
                bereits in einer sicheren Umgebung (Sandbox) läuft, um sich dann
                anders zu verhalten und nicht entdeckt zu werden.
                <br />
                <br />
                Umgekehrt nutzen auch Sicherheitsanbieter KI, um neue
                Bedrohungen schneller und effektiver zu erkennen. Maschinelles
                Lernen hilft dabei, ungewöhnliches Verhalten zu identifizieren,
                das auf einen Angriff hindeuten könnte, selbst wenn es sich um
                eine bisher unbekannte Malware handelt. Die KI reagiert darauf
                in Echtzeit und blockiert verdächtige Aktivitäten, isoliert
                Netzwerke oder leitet andere defensive Maßnahmen ein.
                <br />
                <br />
                Dieses "Wettrüsten" zwischen Angreifern und Verteidigern wird
                sich immer weiter intensivieren, da KI-Technologien immer
                leistungsfähiger werden.
              </p>
            </div>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter3_1;
